import Colors from '@polestar/component-warehouse-react/tokens/colors/Colors';
const VerticalNavigationTheme = {
    verticalNavigation: {
        light: {
            states: {
                enabled: {
                    color: Colors.black,
                },
                selected: {
                    color: Colors.accessibleSafetyOrange,
                },
            },
        },
        dark: {
            states: {
                enabled: {
                    color: Colors.white,
                },
                selected: {
                    color: Colors.accessibleSafetyOrange,
                },
            },
        },
    },
};
export default VerticalNavigationTheme;
